import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface Props {
  id: string;
  children: React.ReactElement;
}

const PasswordTooltip = ({ id, children }: Props) => {
  const { t } = useTranslation(["pages"]);

  if (!children || !id) {
    return null;
  }

  const renderTooltip = (props: any) => (
    <Tooltip id={`tooltip-${id}`} {...props}>
      {t("password.tooltips.charLengthCheck")}
      <br />
      {t("password.tooltips.alphanumericCheck")}
      <br />
      {t("password.tooltips.digitCheck")}
      <br />
      {t("password.tooltips.lowercaseCheck")}
      <br />
      {t("password.tooltips.uppercaseCheck")}
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="right" overlay={renderTooltip}>
      {children}
    </OverlayTrigger>
  );
};

export default PasswordTooltip;
